import React from 'react'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'
import { ROUTE_URLS } from 'router/routes'

import CasinoIcon from 'shared/img/navIcons/casino.png'
import LiveCasinoIcon from 'shared/img/navIcons/livecasino.png'
import LiveSportIcon from 'shared/img/navIcons/livesport.png'
import SportIcon from 'shared/img/navIcons/sport.png'

import { localeCommonKeysType } from 'shared/locale/en-US'

export type INavMenuSubItem = {
  route: string
  name: localeCommonKeysType
}
export interface INavMenuItem {
  img: string
  title: Union<localeCommonKeysType, string>
  route: string
  isModal?: boolean
  isAuthRequired?: boolean
  subItems?: INavMenuSubItem[]
}

export const navMenuItems: INavMenuItem[] = [
  {
    img: SportIcon,
    route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Home'),
    // route: MODAL_ROUTE_URLS.CHOOSE_SPORT('sport'),
    // isModal: true,
    title: 'sport',
    // subItems: [
    //   {
    //     name: 'sport1',
    //     route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Home'),
    //   },
    //   {
    //     name: 'sport2',
    //     route: ROUTE_URLS.BETBY_SPORT(),
    //   },
    //   {
    //     name: 'sport3',
    //     route: ROUTE_URLS.SOFTION_SPORT(),
    //   },
    // ],
  },
  {
    img: LiveSportIcon,
    route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Live'),
    // route: MODAL_ROUTE_URLS.CHOOSE_SPORT('liveSport'),
    // isModal: true,
    title: 'liveSport',
    // subItems: [
    //   {
    //     name: 'liveSport1',
    //     route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Live'),
    //   },
    //   {
    //     name: 'liveSport2',
    //     route: ROUTE_URLS.BETBY_SPORT('live'),
    //   },
    //   {
    //     name: 'liveSport3',
    //     route: ROUTE_URLS.SOFTION_SPORT_LIVE(),
    //   },
    // ],
  },
  {
    img: CasinoIcon,
    title: 'casino',
    route: ROUTE_URLS.SLOTS_CASINO(),
  },
  {
    img: LiveCasinoIcon,
    title: 'liveCasino',
    route: ROUTE_URLS.LIVECASINO(),
  },
]
